import axios from 'axios'

export default class HttpClient {
    #apiToken

    constructor() {
        this.#bindVariables()
    }

    #bindVariables() {
        this.#apiToken = document.querySelector('meta[name="api-token"]').content
    }

    #getConfig() {
        return {
            headers: {
                Authorization: 'Bearer ' + this.#apiToken,
            },
        }
    }

    get(url) {
        return axios.get(url, this.#getConfig())
    }

    post(url, data) {
        return axios.post(url, data, this.#getConfig())
    }
}
